import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
// Icons
import { FaChevronDown } from 'react-icons/fa6';
import { IoMdMenu } from 'react-icons/io';
// Images
import MainLogoImage from '../../assets/images/logos/mistress-md-professional-dominatrix-delicious-logo-no-background.avif';
// Constants
import { CompanyName, HOME_PAGE_URL } from '../../utils/Constants';
// Data
import { navLinkItemsArray } from '../../utils/data/NavData';

function Navbar() {
  const [isPhoneNavOpen, setIsPhoneNavOpen] = useState(false);
  const [isSessionsOpen, setIsSessionsOpen] = useState(false);

  const togglePhoneNav = () => setIsPhoneNavOpen((prev) => !prev);
  const toggleSessionsMenu = () => setIsSessionsOpen((prev) => !prev);

  return (
    <nav
      role='navigation'
      aria-label='Main Navigation'
      className='relative bg-colour4 lg:shadow-md h-fit '
    >
      <section className='grid grid-cols-reg px-4 py-4'>
        <section>
          <NavLink to={HOME_PAGE_URL}>
            <img
              src={MainLogoImage}
              alt={`${CompanyName} business logo - White Logo`}
              className='min-w-10 max-h-[48px] cursor-pointer active:scale-95'
            />
          </NavLink>
        </section>

        <section className='grid items-center justify-end'>
          {/* Mobile screen */}
          <button
            aria-label='Toggle navigation menu'
            onClick={togglePhoneNav}
            className='grid lg:hidden w-fit h-fit items-center justify-center text-4xl text-colour1 cursor-pointer'
          >
            <IoMdMenu className='active:scale-90 duration-300' />
          </button>

          {/* Large screen */}
          <ul className='hidden lg:flex gap-4 lg:gap-5 w-fit mx-auto items-center'>
            {navLinkItemsArray.map(({ path, label, subpages }) =>
              subpages ? (
                <li key={label} className='relative group'>
                  <span className='no__highlights cursor-pointer text-xs xl:text-sm hover:text-colour1  font-StencilW01 hover:brightness-90 duration-200 active:scale-75'>
                    {label}
                  </span>
                  <ul className='absolute left-0 top-full mt-2 bg-white shadow-cardShadowBold rounded-md p-3 grid gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200'>
                    {subpages.map(({ path, label }) => (
                      <div
                        key={label}
                        className='border-b-[1px] border-solid border-colour2'
                      >
                        <NavItem url={path} title={label} />
                      </div>
                    ))}
                  </ul>
                </li>
              ) : (
                <NavItem key={label} url={path} title={label} />
              )
            )}
          </ul>
        </section>
      </section>

      {/* Phone navbar */}
      <section
        className={`phone-nav absolute top-full left-0 w-full bg-colour4 transition-transform duration-300 ${
          isPhoneNavOpen
            ? 'translate-y-0 opacity-100'
            : '-translate-y-full opacity-0'
        }`}
      >
        <ul className='grid gap-8 text-center py-12 shadow-md shadow-colour2/50 no__highlights'>
          {navLinkItemsArray.map(({ path, label, subpages }) =>
            subpages ? (
              <li key={label}>
                <div
                  className='flex justify-center gap-4 hover:brightness-90 duration-200'
                  onClick={toggleSessionsMenu}
                >
                  <span className='text-2xl lg:text-xs xl:text-sm hover:text-colour1 font-StencilW01 no__highlights'>
                    {label}
                  </span>
                  <span
                    className={`flex transition-transform duration-300 ${
                      isSessionsOpen ? 'rotate-180 mb-1.5' : 'mt-1'
                    }`}
                  >
                    <FaChevronDown />
                  </span>
                </div>
                {isSessionsOpen && (
                  <ul className='grid gap-6 mt-2 bg-gray-200 py-4 border-b-2 border-t-2 border-solid border-colour2 no__highlights'>
                    {subpages.map(({ path, label }) => (
                      <NavItem key={label} url={path} title={label} />
                    ))}
                  </ul>
                )}
              </li>
            ) : (
              <NavItem key={label} url={path} title={label} />
            )
          )}
        </ul>
      </section>
    </nav>
  );
}

const NavItem = ({ url, title }) => {
  return (
    <li className='active:scale-90'>
      <NavLink
        to={url}
        aria-label={`${title} page navigation tab`}
        className='text-2xl lg:text-xs xl:text-sm font-StencilW01 hover:text-colour1 hover:brightness-90 duration-200 active:scale-75'
        aria-current={({ isActive }) => (isActive ? 'page' : undefined)}
      >
        {title}
      </NavLink>
    </li>
  );
};

export default Navbar;
